import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'are_loans_advances_line_legal_requirements'

export const dataPointDefinition = {
  retracedId: 'are_loans_advances_line_legal_requirements',
  name: 'Are all loans and/or advances in line with legal requirements?',
  description:
    'For example, legal requirements might stipulate what type of interest rate loans and/or advances can be charged, what the repayment terms should include, etc. ',
  meta: {
    slcpMeta: {
      key: 'wb-17--1',
      number: 'WB-WAGE-114',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wb-17--1', version: '1.7.0', provider: 'slcp'}],
  sortingId: 35100,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
